import React, { useState } from "react";
import {
    Box,
    Typography,
    Container,
    useMediaQuery,
    Divider,
    Grid,
} from "@mui/material";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

// BACKGROUND IMAGE
import { Tribuja } from "../../assets";

const MasterLayout: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const [photoIndex, setPhotoIndex] = useState(0);

    const isMobile = useMediaQuery("(max-width:900px)");

    // ================= STATIC DATA =================

    const layoutImage =
        "https://dprstorage.b-cdn.net/RW/tribuja/tribhuja%20ms.png";

    const images = [layoutImage];

    const highlights = [
        "Built across 9 premium towers with G+37 floors",
        "Spacious 3 & 4 BHK residences",
        "76% open landscaped spaces",
        "1 lakh sq.ft luxury clubhouse",
        "Dedicated wellness, sports & leisure zones",
        "Premium sky-level lifestyle experiences",
        "Multiple pools, gardens & social spaces",
        "Grand arrival plaza with iconic architecture",
    ];

    return (
        <Box
            sx={{
                width: "100%",
                overflow: "hidden",
                position: "relative",
            }}
        >
            <Box
                sx={{
    position: "relative",

    width: "100%",

    backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg.png")`,

    backgroundSize: "cover",

    backgroundPosition: "bottom center",

    backgroundRepeat: "no-repeat",

    py: 8,

    overflow: "hidden",

    "&::after": {
      content: '""',

      position: "absolute",

      top: 0,

      left: 0,

      width: "100%",

      height: "100%",

      backgroundColor: "rgba(0,0,0,0.65)",

      zIndex: 1,
    },
  }}
            >
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            position: "relative",

                            zIndex: 2,
                        }}
                    >
                        {/* TITLE */}

                        <Box
                            sx={{
                                textAlign: "center",

                                color: "white",

                                mb:3,
                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{

                                    fontFamily: "Luxury",
                                    fontWeight: 500,

                                    color: "#fff",

                                    letterSpacing: "1px",

                                    textTransform: "uppercase",

                                    mb: 2,
                                }}
                            >
                                MASTER LAYOUT
                            </Typography>

                            <Box
                                sx={{
                                    width: {
                                        xs: "120px",
                                        md: "180px",
                                    },

                                    height: "2px",

                                    background:
                                        "linear-gradient(to right, transparent, #fff, transparent)",

                                    mx: "auto",

                                    mb: 3,
                                }}
                            />

                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: isMobile ? "14px" : "14px ",

                                    maxWidth: "1200px",

                                    mx: "auto",

                                    color: "#ffffff",

                                    lineHeight: 1.8,

                                    opacity: 0.9,
                                    // fontFamily: "HandilPro",
                                    letterSpacing:"1px",
                                    textAlign:{xs:"start",md:"center"}
                                }}
                            >
                                Tribhuja’s master plan is designed to balance luxury, openness, and community living. Spread across 9.16 acres, the development features nine elegantly planned towers surrounded by landscaped greens, activity zones, leisure spaces, and lifestyle-driven amenities.
                            </Typography>
                        </Box>

                        {/* CONTENT */}

                        <Grid
                            container
                            spacing={5}
                            alignItems="center"
                            justifyContent="center"
                        >
                            {/* IMAGE */}

                            <Grid item xs={12} md={7}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        maxWidth: 600,
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setIsOpen(true)}
                                >
                                    <Box
                                        component="img"
                                        src={layoutImage}
                                        alt="Master Layout"
                                        sx={{
                                            width: "100%",
                                            height: "400px",
                                            borderRadius: 8,

                                            //   display: "block",

                                            transition: "0.4s",

                                            "&:hover": {
                                                transform: "scale(1.03)",
                                            },
                                        }}
                                    />
                                </Box>
                            </Grid>

                            {/* HIGHLIGHTS */}

                            <Grid item xs={12} md={5}>
                                <Box
                                    sx={{
                                        display: "flex",

                                        flexDirection: "column",

                                        justifyContent: "center",

                                        height: "100%",
                                    }}
                                >
                                    {highlights.map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: "flex",

                                                alignItems: "center",

                                                mb: 2.5,
                                            }}
                                        >
                                            <FiberManualRecordIcon
                                                sx={{
                                                    color: "#ffffff",

                                                    fontSize: "10px",

                                                    mr: 2,
                                                }}
                                            />

                                            <Typography
                                            variant="body2"
                                                sx={{
                                                    color: "white",

                                                    fontSize: isMobile ? "14px" : "14px ",

                                                    letterSpacing: 1,

                                                    fontWeight: 400,
                                                    textAlign:"start",
                                                    // fontFamily: "PoetsenOne",
                                                }}
                                            >
                                                {item}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Grid>
                        </Grid>

                        {/* LIGHTBOX */}

                        {isOpen && (
                            <Lightbox
                                mainSrc={images[photoIndex]}
                                nextSrc={images[(photoIndex + 1) % images.length]}
                                prevSrc={
                                    images[(photoIndex + images.length - 1) % images.length]
                                }
                                onCloseRequest={() => setIsOpen(false)}
                                onMovePrevRequest={() =>
                                    setPhotoIndex(
                                        (photoIndex + images.length - 1) % images.length
                                    )
                                }
                                onMoveNextRequest={() =>
                                    setPhotoIndex((photoIndex + 1) % images.length)
                                }
                            />
                        )}
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default MasterLayout;